(function () {
/* eslint-env browser */ // main.js
/* eslint-env browser */ // formAlerts.mjs
const $a53662a993bb2f1c$export$923ea8233b386e99 = "https://us-central1-sowa-52396.cloudfunctions.net/api/contactform";
const $a53662a993bb2f1c$export$ba25a89b7c4dda5a = 15000; // submission times out after 15 sec
const $a53662a993bb2f1c$export$cde4af1fbea6cef2 = 2200; // success alert auto-close after ~2 sec
const $a53662a993bb2f1c$export$7b7637218245c8a = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z][a-zA-Z0-9-]{0,5}[a-zA-Z]$/;


const $41b0c2a14aabb023$var$alertDlg = document.getElementById("contact-form-dialog");
const $41b0c2a14aabb023$var$alertContent = $41b0c2a14aabb023$var$alertDlg.querySelector(".content-wrapper");
const $41b0c2a14aabb023$var$btnSubmit = document.getElementById("contact-form__btn-submit");
let $41b0c2a14aabb023$var$alertTimer;
const $41b0c2a14aabb023$export$3ded2047dae58ffd = {
    ERROR: "error",
    SUCCESS: "success",
    INFO: "info"
};
let $41b0c2a14aabb023$export$af671f97885ca8bf = false; // show or hide modal dialog
function $41b0c2a14aabb023$export$fda836b14bcbd48a(alertType, alertTitle, alertMessage, isModal = true) {
    if ($41b0c2a14aabb023$export$af671f97885ca8bf) return; // don't show alert if modal is open
    // for error alert convert the array of of errors to HTML list
    if (alertType === $41b0c2a14aabb023$export$3ded2047dae58ffd.ERROR && typeof alertMessage === "object") alertMessage = "<ul>" + alertMessage.map((item)=>`<li>${item}</li>`).join("") + "</ul>";
    $41b0c2a14aabb023$var$alertContent.innerHTML = `
      <h4 class="dialog-title">${alertTitle}</h4>
      <div class="dialog-message">${alertMessage}</div>
      <button type="button" class="btn--dlg-circle">`;
    // disable form submit button
    $41b0c2a14aabb023$var$alertDlg.classList.add(alertType);
    if (isModal) {
        $41b0c2a14aabb023$var$btnSubmit.disabled = true;
        $41b0c2a14aabb023$var$alertDlg.showModal();
    } else $41b0c2a14aabb023$var$alertDlg.show();
    // disable handling scrolling and touch swipes
    $41b0c2a14aabb023$export$af671f97885ca8bf = true;
    // for success alert auto-close after 3 seconds
    if (alertType === $41b0c2a14aabb023$export$3ded2047dae58ffd.SUCCESS) $41b0c2a14aabb023$var$alertTimer = setTimeout($41b0c2a14aabb023$export$a74437f92553f720, (0, $a53662a993bb2f1c$export$cde4af1fbea6cef2));
}
function $41b0c2a14aabb023$export$a74437f92553f720() {
    $41b0c2a14aabb023$var$alertContent.innerHTML = "";
    $41b0c2a14aabb023$var$alertDlg.close();
    $41b0c2a14aabb023$var$alertDlg.classList.remove($41b0c2a14aabb023$export$3ded2047dae58ffd.ERROR, $41b0c2a14aabb023$export$3ded2047dae58ffd.SUCCESS);
    // re-enable form submit button
    $41b0c2a14aabb023$var$btnSubmit.disabled = false;
    // re-enable handling scrolling and touch swipes
    $41b0c2a14aabb023$export$af671f97885ca8bf = false;
    clearTimeout($41b0c2a14aabb023$var$alertTimer);
}
/**** Event listeners ****/ // click anywhere on the alert element to close
$41b0c2a14aabb023$var$alertContent.addEventListener("click", $41b0c2a14aabb023$export$a74437f92553f720);
// hit ESC while the alert is open to close
$41b0c2a14aabb023$var$alertDlg.addEventListener("keydown", (e)=>{
    if (e.key === "Escape") $41b0c2a14aabb023$export$a74437f92553f720();
});


/* eslint-env browser */ // formSubmit.mjs

const $86b45122469d2b7d$var$btnSubmit = document.getElementById("contact-form__btn-submit");
/**
 * Changes the appearance of the submit button to indicate
 * that the form is being processed.
 *
 * @param {boolean} processing - Indicates if the submission is being processed
 * @return {void}
 */ function $86b45122469d2b7d$var$setProcessingMode(processing) {
    if (processing) {
        $86b45122469d2b7d$var$btnSubmit.disabled = true;
        $86b45122469d2b7d$var$btnSubmit.textContent = "Sending...";
        $86b45122469d2b7d$var$btnSubmit.classList.add("btn--spinner");
    } else {
        $86b45122469d2b7d$var$btnSubmit.classList.remove("btn--spinner");
        $86b45122469d2b7d$var$btnSubmit.textContent = "Send";
        $86b45122469d2b7d$var$btnSubmit.disabled = false;
    }
}
async function $86b45122469d2b7d$export$e02251cfbe407ee6(formData) {
    try {
        // indicate the submission is being processed
        $86b45122469d2b7d$var$setProcessingMode(true);
        const objData = {
            name: formData.get("name"),
            email: formData.get("email"),
            phone: formData.get("phone"),
            message: formData.get("message")
        };
        // console.log("Sending data: ", objData);
        // timeout request after specified time
        const timeoutPromise = new Promise((_, reject)=>setTimeout(()=>reject(new Error("Submission timed out")), (0, $a53662a993bb2f1c$export$ba25a89b7c4dda5a)));
        const response = await Promise.race([
            fetch((0, $a53662a993bb2f1c$export$923ea8233b386e99), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(objData)
            }),
            timeoutPromise
        ]);
        if (response instanceof Response) {
            // console.log("Response:", response);
            const responseData = await response.text();
            if (!response.ok) // handle server error
            // console.log("Error message:", responseData);
            return {
                status: "error",
                message: responseData
            };
            // handle success
            // console.log("Server response:", responseData);
            return {
                status: "success",
                message: "Email sent successfully!"
            };
        }
    } catch (error) {
        return {
            status: "error",
            message: error.message
        };
    } finally{
        $86b45122469d2b7d$var$setProcessingMode(false);
    }
}


// utility function - returns a title-case version of a string
function $efc193db56ace37e$var$toTitleCase(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
// validation parameters
const $efc193db56ace37e$var$INPUT_MAX_LENGTH = 50;
const $efc193db56ace37e$var$MESSAGE_MAX_LENGTH = 400;
// validation constraints
const $efc193db56ace37e$var$CONSTRAINTS = {
    INPUT_REQUIRED: "REQUIRED",
    INPUT_FORMAT_EMAIL: "EMAIL"
};
class $efc193db56ace37e$export$56e87bf42978147a {
    constructor(id){
        this.id = id;
        try {
            this._domElement = document.getElementById(id);
            if (!this._domElement) throw new Error("Form field with id " + id + " not found");
        // This is not necessary for our use case:
        // add a change event listener (also can use unput event for text fields)
        // this._domElement.addEventListener("change", (e) => {
        //   this._value = e.target.value;
        // });
        } catch (err) {
            console.error(err);
        }
    }
    // public property getters
    get value() {
        return this._domElement.value;
    }
    get type() {
        return this._domElement.type;
    }
    get name() {
        return this._domElement.name;
    }
    get title() {
        return $efc193db56ace37e$var$toTitleCase(this._domElement.name); // name in title case
    }
    get validationError() {
        return this.validate(this._getAutoConstraints());
    }
    get isValid() {
        return this.validate(this._getAutoConstraints()) === "";
    }
    // internal property getters
    get _isBlank() {
        return this._domElement.value === "";
    }
    get _isRequired() {
        return this._domElement.required || this._domElement.hasAttribute("required") || this._domElement.classList.contains("required");
    }
    get _isText() {
        return this._domElement.type === "text";
    }
    get _isEmail() {
        return this._domElement.type === "email";
    }
    get _isEmailValid() {
        return this._domElement.validity.valid;
    }
    get _isMaxLengthExceeded() {
        return this._domElement.value.length > $efc193db56ace37e$var$INPUT_MAX_LENGTH;
    }
    get _isMessageMaxLengthExceeded() {
        return this._domElement.value.length > $efc193db56ace37e$var$MESSAGE_MAX_LENGTH;
    }
    /**
   * Derives the constraints based on the form field properties and classes.
   *
   * @return {array} The array of constraints or an empty array.
   */ get _autoConstraints() {
        const constraints = [];
        if (this._isRequired) constraints.push($efc193db56ace37e$var$CONSTRAINTS.INPUT_REQUIRED);
        if (this._isEmail) constraints.push($efc193db56ace37e$var$CONSTRAINTS.INPUT_FORMAT_EMAIL);
        return constraints;
    }
    // PUBLIC METHODS
    /**
   * Trim field value in the form.
   *
   * @return {string} trimmedValue - the trimmed value of the field
   */ trim() {
        // trim field value in the form
        const currentValue = this.value;
        const trimmedValue = this.value.trim();
        // note: type="email" field value always gets trimmed internally
        if (currentValue !== trimmedValue || this._isEmail) this._domElement.value = trimmedValue;
        return trimmedValue; // return value is not always used
    }
    /**
   * Validate the field value based on the given constraints.
   *
   * @param {Array} constraints - The constraints to validate against
   * @return {string} The error message, if any
   */ validate(constraints) {
        // validate the trimmed field value
        const trimmedValue = this.trim();
        // for required field, return the 'required' error message
        if (constraints.includes($efc193db56ace37e$var$CONSTRAINTS.INPUT_REQUIRED) && trimmedValue === "") return this.title + " is required.";
        // for ALL text and email fields regardless of constraints, validate the max value length
        if ((this._isText || this._isEmail) && trimmedValue.length > $efc193db56ace37e$var$INPUT_MAX_LENGTH) return this.title + " exceeds the max length of " + $efc193db56ace37e$var$INPUT_MAX_LENGTH + ".";
        // for message field, validate the max value length
        if (this.type === "textarea" && trimmedValue.length > $efc193db56ace37e$var$MESSAGE_MAX_LENGTH) return this.title + " exceeds the max length of " + $efc193db56ace37e$var$MESSAGE_MAX_LENGTH + ".";
        // for email field, validate the input value and return the 'email' error message
        if (constraints.includes($efc193db56ace37e$var$CONSTRAINTS.INPUT_FORMAT_EMAIL)) {
            const emailValidationResult = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z][a-zA-Z0-9-]{0,5}[a-zA-Z]$/.test(this.value);
            if (!emailValidationResult) return "Invalid email address.";
        }
        return "";
    }
    /**
   * Validate with constraints derived from form field properties and classes.
   *
   * @return {string} the error message or an empty string, if no error
   */ validateWithAutoConstraints() {
        return this.validate(this._autoConstraints);
    }
}
/**
 * Retrieves all input and textarea elements within a form and returns them as
 * an object with the element id as the key and the element object as the value.
 *
 * @param {HTMLElement} form - The form element to search for input elements.
 * @return {Object} inputElements - The input elements within the form as an object.
 */ function $efc193db56ace37e$var$getInputElementsInForm(form) {
    const inputElements = {};
    if (form) {
        const inputFields = form.querySelectorAll("input, textarea");
        inputFields.forEach((element)=>{
            if (element.id && (element.tagName === "INPUT" || element.tagName === "TEXTAREA")) inputElements[element.id] = element;
        });
    }
    return inputElements;
}
class $efc193db56ace37e$export$cd58ffd7e3880e66 {
    constructor(formId){
        try {
            this._form = document.getElementById(formId);
            if (!this._form) throw new Error("Form with id " + formId + " not found");
            this._FormFields = [];
            // get all input and textarea elements
            const inputElements = $efc193db56ace37e$var$getInputElementsInForm(this._form);
            Object.values(inputElements).forEach((element)=>{
                const field = new $efc193db56ace37e$export$56e87bf42978147a(element.id);
                this._FormFields.push(field);
            // console.log(field.title, "constraints: ", field._autoConstraints);
            });
        } catch (err) {
            console.error(err);
        }
    }
    // public methods
    trimAll() {
        this._FormFields.forEach((field)=>{
            field.trim();
        });
    }
    validateAllWithAutoConstraints() {
        const validationResult = this._FormFields.reduce((result, field)=>{
            const fieldValodationResult = field.validateWithAutoConstraints();
            if (fieldValodationResult) result.push(fieldValodationResult);
            return result;
        }, []);
        return validationResult;
    }
}


document.addEventListener("DOMContentLoaded", ()=>{
    const logo = document.getElementById("main-logo");
    const scroller = document.querySelector(".content-scroller");
    const sections = document.querySelectorAll(".section");
    const topNav = document.getElementById("top-nav");
    const menuHamburger = document.getElementById("menu-hamburger");
    const menuClose = document.getElementById("menu-close");
    const menuButtons = document.querySelectorAll(".menu-item");
    const contactButton = document.getElementById("btn__contact");
    const nextButton = document.getElementById("nav-btn__nextpg");
    const contactForm = document.getElementById("contact-form");
    let currentSectionIndex = 0;
    let isPrivacyTermsHidden = true; // show or hide Privacy & Terms block
    /***** FUNCTIONS FOR SECTION SCROLLING - WHEEL AND TOUCH HANDLERS *****/ // event handler flags
    let isHandlingWheel = true;
    let isHandlingSwipe = true;
    let touchStartY = 0;
    function handleTouchStart(event) {
        // event.preventDefault();
        touchStartY = 0;
        isHandlingWheel = false;
        // Disable for desktop, if modal is open,
        // or handling touch events for nav buttons/inputs
        if (isHandlingSwipe && window.innerWidth < 1024 && !(0, $41b0c2a14aabb023$export$af671f97885ca8bf) && !event.target.classList.contains("nav-btn") && !event.target.classList.contains("btn") && !event.target.classList.contains("contact-input")) // handle touch-swipe
        touchStartY = event.touches[0].clientY;
        isHandlingWheel = true;
        isHandlingSwipe = true;
    }
    function handleTouchMove(event) {
        // event.preventDefault();
        // Disable for desktop, if modal is open, or handling touch events for nav buttons/inputs
        if (isHandlingSwipe && window.innerWidth < 1024 && !(0, $41b0c2a14aabb023$export$af671f97885ca8bf) && touchStartY && event.changedTouches[0] && !event.target.classList.contains("nav-btn") && !event.target.classList.contains("btn") && !event.target.classList.contains("contact-input")) {
            // handle touch-swipe
            const touchEndY = event.changedTouches[0].clientY;
            const deltaY = touchEndY - touchStartY;
            // console.log("handleTouvhMove: " + touchStartY + "/" + deltaY);
            if (Math.abs(deltaY) > 0) {
                event.preventDefault();
                // Determine the direction of swiping
                navigate(deltaY > 0 ? -1 : 1);
            }
            touchStartY = 0;
            isHandlingWheel = true;
            isHandlingSwipe = true;
        }
    }
    // Function to handle mouse wheel events
    function handleWheel(e) {
        // Prevent the default behavior to avoid page scrolling
        e.preventDefault();
        // Disable handling wheel events for mobile screens
        if (window.innerWidth < 1024) return;
        // If handling wheel events is paused, do nothing
        if (!isHandlingWheel || (0, $41b0c2a14aabb023$export$af671f97885ca8bf)) return;
        // Delay handling immediate next wheel events
        isHandlingWheel = false;
        isHandlingSwipe = false;
        // Determine the direction of scrolling
        const direction = e.deltaY > 0 ? 1 : -1;
        navigate(direction);
        // Re-enable handling wheel events after a timeout
        setTimeout(()=>{
            isHandlingWheel = true;
            isHandlingSwipe = true;
        }, 2000);
    }
    /***** FUNCTIONS FOR SECTION NAVIGATION AND RENDERING *****/ // Function that increment/decrements the current position and triggers UI update
    function navigate(dir) {
        if (dir === 1 && currentSectionIndex < sections.length - 1) currentSectionIndex++;
        else if (dir === -1 && currentSectionIndex > 0) currentSectionIndex--;
        // update UI
        renderSections();
    }
    // Function that sets the current section to a specified index
    // and triggers the UI update
    function navigateTo(index) {
        if (index !== currentSectionIndex) {
            currentSectionIndex = index;
            renderSections();
        }
    }
    // Function that handles updating UI on navigation change
    function renderSections() {
        // scroller dataset controls position
        scroller.dataset.section = String(currentSectionIndex);
        // Check if last section is active and hide nextButton
        nextButton.style.display = currentSectionIndex === sections.length - 1 ? "none" : "inline-block";
        // mark current section active
        sections.forEach((section, index)=>{
            if (index === currentSectionIndex) section.classList.add("active");
            else section.classList.remove("active");
        });
        // mark current menu button active
        menuButtons.forEach((menuItem)=>{
            if (menuItem.dataset.sectionId === String(currentSectionIndex)) menuItem.classList.add("active");
            else menuItem.classList.remove("active");
        });
        // for mobile, clear active service selection when Services section is shown
        if (currentSectionIndex === 1 && window.innerWidth < 768) clearActiveService();
        // close Privacy & Terms modal (if open)
        hidePrivacyTermsInfo();
        // close form modal (if open)
        const modalDlg = document.getElementById("contact-form-dialog");
        if (modalDlg.open) modalDlg.close();
    }
    /***** FUNCTIONS FOR SERVICES SECTION [1] LOGIC *****/ const servicesList = document.getElementById("services-list");
    const serviceDetails = document.querySelectorAll(".service-details");
    // used for desktop resolution only - by default, select the first service item
    function setDefaultService() {
        // mark the first service as active
        const s1 = document.querySelector("li.service[data-id='s1']");
        s1.classList.add("active");
        // mark the first service detail as active
        const sd1 = document.getElementById("s1");
        sd1.classList.add("active");
    }
    // removes .active class from all services and service-detail elements
    function clearActiveService() {
        const activeServices = document.querySelectorAll("li.service.active");
        activeServices.forEach((service)=>service.classList.remove("active"));
        const activeServiceDetails = document.querySelectorAll(".service-details.active");
        activeServiceDetails.forEach((detail)=>detail.classList.remove("active"));
        // unhide the service list if it is hidden
        servicesList.classList.remove("hidden");
    }
    // service list item selection
    servicesList.addEventListener("click", (e)=>{
        const selectedId = e.target.dataset.id;
        if (!selectedId) return;
        // for desktop & tablet resolutions, mark selected service list item as active
        if (window.innerWidth >= 768) {
            const selectedService = e.target;
            // if user clicked on the currently active list item, do nothing
            if (selectedService.classList.contains("active")) return;
            // unselect the previously active item
            const currentActiveService = document.querySelector(".service.active");
            currentActiveService?.classList.remove("active");
            // mark the selected item active
            selectedService?.classList.add("active");
        } else // for mobile resolutions, hide the section title and services list,
        // sectionTitle.classList.add("hidden");
        servicesList.classList.add("hidden");
        //clear active service and mark selected service detail as active
        const currentActiveDetail = document.querySelector(".service-details.active");
        currentActiveDetail?.classList.remove("active");
        // mark the selected item active
        const selectedDetail = document.getElementById(selectedId);
        selectedDetail?.classList.add("active");
    });
    // event listener for service-details click
    serviceDetails.forEach((detail)=>detail.addEventListener("click", ()=>{
            // for mobile resolution, unmark currently selected service description as active
            // and show section title and services list
            if (window.innerWidth < 768) clearActiveService();
        }));
    /***** FUNCTIONS FOR CONTACT FORM - SECTION [4] *****/ // form validation and submittion
    // replace 'Enter' keystrokes inside all input elements with 'Tab' keystrokes
    const inputFields = Array.from(contactForm.querySelectorAll("input, textarea"));
    inputFields.forEach((field)=>{
        if (field.tagName === "INPUT") {
            // get a handle to the next form field
            const nextFieldIndex = inputFields.indexOf(field) + 1;
            field.addEventListener("keydown", (e)=>{
                if (e.key === "Enter") {
                    e.preventDefault(); // Prevent the default behavior of the Enter key
                    inputFields[nextFieldIndex]?.focus();
                }
            });
        }
    });
    // form validation
    const formVal = new (0, $efc193db56ace37e$export$cd58ffd7e3880e66)("contact-form");
    contactForm.addEventListener("submit", async (e)=>{
        e.preventDefault();
        // validate the form
        const validationErrors = formVal.validateAllWithAutoConstraints();
        if (validationErrors.length > 0) {
            (0, $41b0c2a14aabb023$export$fda836b14bcbd48a)((0, $41b0c2a14aabb023$export$3ded2047dae58ffd).ERROR, "Please correct the following:", validationErrors);
            return;
        }
        // if all fields are valid, send the data to the server;
        // the fields values are trimmed during validation.
        const formData = new FormData(e.target);
        const submitResponse = await (0, $86b45122469d2b7d$export$e02251cfbe407ee6)(formData);
        if (submitResponse.status === "error") {
            // use obfuscated email address
            (0, $41b0c2a14aabb023$export$fda836b14bcbd48a)((0, $41b0c2a14aabb023$export$3ded2047dae58ffd).ERROR, submitResponse.message, "Please send us an email at: info&#64;<b>msg-</b>sowa&#46;dev");
            return;
        }
        // on success reset the form and show success message
        contactForm.reset();
        (0, $41b0c2a14aabb023$export$fda836b14bcbd48a)((0, $41b0c2a14aabb023$export$3ded2047dae58ffd).SUCCESS, "Your message has been sent", "Thank you!<br />We will get back you asap.");
    });
    /***** FUNCTIONS FOR CONTROLLING THE PRIVACY & TERMS MODAL *****/ // show/hide Privacy & Terms Info modal
    function showPrivacyTermsInfo() {
        if (!isPrivacyTermsHidden) return;
        // const contactsBlock = document.getElementById("contacts");
        // hide Contacts section content
        const contactsSectionContent = document.querySelector("#section-contacts .section-content");
        const termsBlock = document.getElementById("terms");
        contactsSectionContent.classList.add("hidden");
        termsBlock.classList.remove("hidden");
        isPrivacyTermsHidden = false;
    }
    function hidePrivacyTermsInfo() {
        if (isPrivacyTermsHidden) return;
        // unhide Contacts section content
        const contactsSectionContent = document.querySelector("#section-contacts .section-content");
        const termsBlock = document.getElementById("terms");
        termsBlock.classList.add("hidden");
        contactsSectionContent.classList.remove("hidden");
        isPrivacyTermsHidden = true;
    }
    /***************** EVENT LISTENERS ********************/ // Mouse wheel events
    scroller.addEventListener("wheel", handleWheel);
    // Touch navigation events
    scroller.addEventListener("touchstart", (e)=>handleTouchStart(e));
    scroller.addEventListener("touchmove", (e)=>{
        if (e.changedTouches?.[0]) handleTouchMove(e);
    });
    // Mobile - hamburger and close menu buttons events
    menuHamburger.addEventListener("click", ()=>{
        topNav.classList.add("active");
        menuHamburger.style.display = "none";
        menuClose.style.display = "block";
    });
    function handleMobileMenuClose() {
        topNav.classList.remove("active");
        menuHamburger.style.display = "block";
        menuClose.style.display = "none";
    }
    menuClose.addEventListener("click", handleMobileMenuClose);
    // Logo click event (go back home)
    logo.addEventListener("click", ()=>navigateTo(0));
    // Bottom navigation buttons events
    nextButton.addEventListener("click", ()=>{
        navigate(1); // Pass 1 to go to the next section
    });
    // Top menu buttons click events
    menuButtons.forEach((menuItem)=>menuItem.addEventListener("click", ()=>{
            navigateTo(+menuItem.dataset.sectionId);
            if (window.innerWidth < 1024) handleMobileMenuClose();
        }));
    // `Contact Us` button click event
    contactButton.addEventListener("click", (e)=>{
        e.preventDefault();
        navigateTo(sections.length - 1); // go to the last section
    });
    // Warning card expand/collapse events
    const warningCard = document.getElementById("contact-warning");
    warningCard?.addEventListener("click", ()=>{
        warningCard.classList.toggle("expanded");
    });
    // Privacy & Terms Link click event (footer)
    document.getElementById("footer__terms")?.addEventListener("click", ()=>showPrivacyTermsInfo());
    // Privacy & Terms CLose button
    document.getElementById("terms-close-btn")?.addEventListener("click", ()=>hidePrivacyTermsInfo());
    // Privacy & Terms - Accordion sections events
    const accordionSections = document.querySelectorAll(".accordion-section");
    const accordionSectionHeaders = document.querySelectorAll(".accordion-section h4");
    accordionSectionHeaders.forEach((sectionHeader)=>{
        sectionHeader.addEventListener("click", (e)=>{
            // expand or collapse the parent section
            const parentSection = e.target.closest(".accordion-section");
            if (parentSection.classList.contains("expanded")) parentSection.classList.remove("expanded");
            else {
                // collapse all other sections
                accordionSections.forEach((section)=>{
                    if (section !== parentSection) section.classList.remove("expanded");
                });
                parentSection.classList.add("expanded");
            }
        });
    });
    /**************** APP INITIALIZATION********************/ // in Services section, mark the first service detail as active
    // (tablet & desktop resolution only)
    if (window.innerWidth >= 768) setDefaultService();
    // currentSectionIndex = 3; // TEST MODE ONLY
    renderSections();
});

})();
//# sourceMappingURL=index.b33392fd.js.map
